const codes = {
  maxDevicesError: "571102",
  loginToPlayError: "571108",
  bufferTimeoutError: "571197",
  bufferTimeoutOfflineError: "571199",
  loadTimeoutError: "571198",
  localStorageLog: "571202",
  indexDBLog: "571201"
};

export function getErrorCode(key) {
  return codes[key];
}
